import { TMLevelChip } from 'components/Form/Levels'

export const studentListColumns = [
  {
    Header: 'First name',
    accessor: 'forename',
  },
  {
    Header: 'Last name',
    accessor: 'surname',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Instruction Date',
    accessor: 'instructionDate',
  },
  {
    Header: 'Format',
    accessor: 'userType',
  },
  {
    Header: 'Level',
    accessor: 'level',
    Cell: (props: any) => {
      const level = props.row.original.level as number
      const isLocked = props.row.original.status === 'locked'
      return isLocked ? null : <TMLevelChip level={level} />
    },
  },
  {
    Header: 'Position',
    accessor: 'progress',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
]
export const teacherTrainingListColumns = [
  {
    Header: 'Enrolled Date',
    accessor: 'instructionDate',
  },
  {
    Header: 'First name',
    accessor: 'forename',
  },
  {
    Header: 'Last name',
    accessor: 'surname',
  },
  {
    Header: 'Country',
    accessor: 'countryCode',
  },
  {
    Header: 'Due Date',
    accessor: 'expirationDate',
  },
  {
    Header: 'DC Progress',
    accessor: 'dcProgress',
  },
  {
    Header: 'Training Status',
    accessor: 'status',
  },
]
